import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { JobShortlist } from "../../models/jobshortlist"

@Injectable({
  providedIn: "root",
})
export class JobShortlistDisplayDataResolver implements DisplayDataResolver<JobShortlist> {
  typeDisplayName = "JobShortlist"

  constructor() {}

  getIcon(entity: JobShortlist): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: JobShortlist): string | undefined {
    return undefined
  }

  getSubTitle(entity: JobShortlist): string | undefined {
    return undefined
  }

  getTitle(entity: JobShortlist): string {
    return entity.job.title
  }

  getShortTitle(entity: JobShortlist): string {
    return entity.id
  }

  getItemHref(entityOrID: JobShortlist | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/jobshortlist"
    }
    if (typeof entityOrID === "string") return "/app/jobshortlist/" + entityOrID
    return "/app/jobshortlist/" + entityOrID.id
  }
}
